<template>
  <el-dialog
    :visible.sync="visible"
    width="30%"
    top="30px"
    :destroy-on-close="true"
    :before-close="handleClose"
  >
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane :label="$t('langcfg.txtExportOptions')" name="options">
        <el-tree
          :data="options"
          ref="optiontree"
          show-checkbox
          default-expand-all
          @check="checkChanged"
          node-key="id"
        ></el-tree>
      </el-tab-pane>

      <el-tab-pane :label="$t('langcfg.txtExportFolder')" name="foldername">
        <div style="margin-top: 10px" v-for="(item, index) in folderNames" :key="index">
          <span style="font-size: 25px">{{ index + 1 }}. &nbsp;</span>

          <el-select
            @change="selectedChanged"
            v-model="folderNameSelections[`selection${index + 1}`].value"
            style="margin-top: 15px"
          >
            <el-option
              v-for="item in folderNameSelections[`selection${index + 1}`].selections"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span
            class="el-icon-circle-close"
            style="font-size: 30px; margin-left: 10px"
            @click="clear(index + 1)"
          ></span>
        </div>
        <div style="margin-top: 10px; font-size: 25px; color: white; line-height: 30px">
          {{ folderNameTip }}
        </div>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">{{ $t("langcfg.txtOK") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { saveExportOption } from "../../../settings";
import { EXPORT_OPTIONS } from "../../../settings/consts";
import { isStringEmpty, objectCopy } from "../../../shared/utils";
import { License } from "../../../mixins";

export default {
  name: "ExportOptions",
  mixins: [License],
  data() {
    return {
      activeName: "options",
      options: [],
      selectedOptions: [],
      folderNameSelections: {
        selection1: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtName"),
              value: "name"
            },
            {
              label: "PID",
              value: "pid"
            },
            {
              label: this.$t("langcfg.txtCheckType"),
              value: "checktype"
            },
            {
              label: this.$t("langcfg.txtEye"),
              value: "eye"
            },
            {
              label: this.$t("langcfg.txtCheckTime"),
              value: "checktime"
            }
          ]
        },
        selection2: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtName"),
              value: "name"
            },
            {
              label: "PID",
              value: "pid"
            },
            {
              label: this.$t("langcfg.txtCheckType"),
              value: "checktype"
            },
            {
              label: this.$t("langcfg.txtEye"),
              value: "eye"
            },
            {
              label: this.$t("langcfg.txtCheckTime"),
              value: "checktime"
            }
          ]
        },
        selection3: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtName"),
              value: "name"
            },
            {
              label: "PID",
              value: "pid"
            },
            {
              label: this.$t("langcfg.txtCheckType"),
              value: "checktype"
            },
            {
              label: this.$t("langcfg.txtEye"),
              value: "eye"
            },
            {
              label: this.$t("langcfg.txtCheckTime"),
              value: "checktime"
            }
          ]
        },
        selection4: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtName"),
              value: "name"
            },
            {
              label: "PID",
              value: "pid"
            },
            {
              label: this.$t("langcfg.txtCheckType"),
              value: "checktype"
            },
            {
              label: this.$t("langcfg.txtEye"),
              value: "eye"
            },
            {
              label: this.$t("langcfg.txtCheckTime"),
              value: "checktime"
            }
          ]
        },
        selection5: {
          value: "",
          selections: [
            {
              label: this.$t("langcfg.txtName"),
              value: "name"
            },
            {
              label: "PID",
              value: "pid"
            },
            {
              label: this.$t("langcfg.txtCheckType"),
              value: "checktype"
            },
            {
              label: this.$t("langcfg.txtEye"),
              value: "eye"
            },
            {
              label: this.$t("langcfg.txtCheckTime"),
              value: "checktime"
            }
          ]
        }
      },
      folderNames: [
        {
          label: this.$t("langcfg.txtName"),
          value: "name"
        },
        {
          label: "PID",
          value: "pid"
        },
        {
          label: this.$t("langcfg.txtCheckType"),
          value: "checktype"
        },
        {
          label: this.$t("langcfg.txtEye"),
          value: "eye"
        },
        {
          label: this.$t("langcfg.txtCheckTime"),
          value: "checktime"
        }
      ],
      exportOptions: window.exportOptionSettings.exportOptions,
      folderName: window.exportOptionSettings.folderName,
      folderNameTip: ""
    };
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible;
      },
      set: function (val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },
  methods: {
    handleClose(done) {
      done();
    },
    clear(index) {
      if (this.folderName.filter((item) => item !== "").length === 1) {
        return;
      }
      this.folderName = [];
      this.folderNameSelections["selection" + index].value = "";
      this.normalFolderName();
    },
    normalFolderName() {
      this.folderName = [];
      for (let id in this.folderNameSelections) {
        this.folderName.push(this.folderNameSelections[id].value);
      }
      this.join();
      window.exportOptionSettings.folderName = this.folderName.concat();
      saveExportOption(window.exportOptionSettings);
    },
    join() {
      this.folderNameTip = "";
      let tempArr = [];
      for (let id in this.folderName) {
        if (!isStringEmpty(this.folderName[id])) {
          let key = this.folderName[id].toUpperCase();
          tempArr.push(this.$t(`langcfg.txtExample${key}`));
        }
      }
      this.folderNameTip = `${this.$t("langcfg.txtExample")}: ${tempArr.join("_")}`;
    },
    selectedChanged() {
      this.normalFolderName();
      window.exportOptionSettings.folderName = this.folderName;
      saveExportOption(window.exportOptionSettings);
    },
    checkChanged() {
      this.exportOptions = objectCopy(EXPORT_OPTIONS.exportOptions);
      if (!this.$refs.optiontree) return;
      let checkNodes = this.$refs.optiontree.getCheckedNodes();
      for (let id in checkNodes) {
        let key = checkNodes[id].id;
        if (checkNodes[id].type === "parent") {
          this.exportOptions[key].checked = true;
          for (let idy in this.exportOptions[key].children) {
            this.exportOptions[key].children[idy] = true;
          }
        } else {
          let parent = checkNodes[id].parent;
          this.exportOptions[parent].children[key] = true;
        }
      }

      window.exportOptionSettings.exportOptions = this.exportOptions;
      saveExportOption(window.exportOptionSettings);
    }
  },
  props: {
    dialogVisible: false
  },
  watch: {
    folderName: {
      handler: function () {
        for (let id in this.folderName) {
          this.folderNameSelections[`selection${parseInt(id) + 1}`].value = this.folderName[id];
        }
        const EXPOPTIONS = [
          {
            label: this.$t("langcfg.txtName"),
            value: "name"
          },
          {
            label: "PID",
            value: "pid"
          },
          {
            label: this.$t("langcfg.txtCheckType"),
            value: "checktype"
          },
          {
            label: this.$t("langcfg.txtEye"),
            value: "eye"
          },
          {
            label: this.$t("langcfg.txtCheckTime"),
            value: "checktime"
          }
        ];
        Object.keys(this.folderNameSelections).forEach((key) => {
          this.folderNameSelections[key].selections = EXPOPTIONS.filter((opt) => {
            return (
              this.folderName.indexOf(opt.value) === -1 ||
              this.folderNameSelections[key].value === opt.value
            );
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.isDryEyeEnabled) {
      this.options.push({
        id: "dryeye",
        label: this.$t("langcfg.txtDryEye"),
        type: "parent",
        children: [
          {
            id: "dryeyecsv",
            label: this.$t("langcfg.txtExportTable") + "(CSV)",
            parent: "dryeye"
          },
          {
            id: "nibut",
            label: this.$t("langcfg.txtNibut"),
            parent: "dryeye"
          },
          {
            id: "tearheight",
            label: this.$t("langcfg.txtTearHeight"),
            parent: "dryeye"
          },
          {
            id: "lipidlayer",
            label: this.$t("langcfg.txtLipidLayer"),
            parent: "dryeye"
          },
          {
            id: "meibomian",
            label: this.$t("langcfg.txtMeibomian"),
            parent: "dryeye"
          },
          {
            id: "eyelidedge",
            label: this.$t("langcfg.txtEyelidEdge"),
            parent: "dryeye"
          },
          {
            id: "eyeredness",
            label: this.$t("langcfg.txtEyeRedness"),
            parent: "dryeye"
          },
          {
            id: "ocularsurface",
            label: this.$t("langcfg.txtOcularSurface"),
            parent: "dryeye"
          },
          {
            id: "fbut",
            label: this.$t("langcfg.txtBut"),
            parent: "dryeye"
          },
          {
            id: "blink",
            label: this.$t("langcfg.txtBlink"),
            parent: "dryeye"
          }
        ]
      });
    }
    if (this.isTopographyEnabled) {
      this.options.push({
        id: "topography",
        label: this.$t("langcfg.txtCornealTopography"),
        type: "parent",
        children: [
          {
            id: "topocsv",
            label: this.$t("langcfg.txtExportTable") + "(CSV)",
            parent: "topography"
          },
          {
            id: "originalimage",
            label: this.$t("langcfg.txtOriginalImg"),
            parent: "topography"
          },
          {
            id: "dotEyeFile",
            label: ".eye",
            parent: "topography"
          },
          {
            id: "dotMwfFile",
            label: ".mwf",
            parent: "topography"
          }
        ]
      });
    }
    let selectData = [];
    this.exportOptions = window.exportOptionSettings.exportOptions;
    this.folderName = window.exportOptionSettings.folderName;
    for (let id in this.folderName) {
      this.folderNameSelections[`selection${parseInt(id) + 1}`].value = this.folderName[id];
    }
    this.join();
    for (let id in this.exportOptions) {
      if (this.exportOptions[id].checked) {
        selectData.push({ id });
      } else {
        for (let idy in this.exportOptions[id].children) {
          if (this.exportOptions[id].children[idy]) {
            selectData.push({ id: idy });
          }
        }
      }
    }
    this.$nextTick(() => {
      if (this.$refs.optiontree) {
        this.$refs.optiontree.setCheckedNodes(selectData);
      }
    });
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-tree {
  background: none;
}

/deep/ .el-tree-node__content:hover {
  background-color: #383b3f;
}

/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #383b3f;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: none;
}

/deep/ .el-tree-node__content {
  margin-top: 12px;
}

/deep/ .el-tree-node__label {
  font-size: 25px;
}

/deep/ .el-tree-node {
  padding-top: 5px;
}
.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 60px;
  min-width: 200px;
  font-size: 25px;
}

.el-tabs /deep/ .el-tabs__item {
  color: white;
  font-size: 28px;
  border: none;
}
.el-tabs /deep/.el-tabs__header {
  border: none;
}
.el-tabs /deep/.el-tabs__nav {
  border: none;
  border-bottom: 1px solid rgb(95, 92, 92);
}
.el-tabs /deep/ .is-active {
  color: @blue-selected-color;
}
.el-tabs /deep/ .is-top {
  text-align: center;
}
.el-tabs /deep/ .el-tabs__item:hover {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/exportData/ExportOptions.vue